export const emotionHigh = {
  Família: [
    "Escrever uma carta ou mensagem expressando gratidão a um familiar.",
    "Compartilhar uma lembrança importante com um parente.",
    "Perguntar a alguém da família como tem se sentido.",
  ],
  Amor: [
    "Dizer um sentimento profundo ao parceiro.",
    "Escrever uma carta romântica, mesmo que guarde.",
    "Contar ao parceiro algo que admira nele.",
  ],
  Carreira: [
    "Escrever sobre seu propósito no trabalho.",
    "Compartilhar uma motivação com colega.",
    "Refletir sobre como seu trabalho impacta outras pessoas.",
  ],
  Saúde: [
    "Escrever como se sentiu após se exercitar.",
    "Observar emoções antes/depois de comer.",
    "Fazer um check-in emocional durante o dia.",
  ],
  Social: [
    "Mandar uma mensagem sincera.",
    "Falar algo bonito a alguém.",
    "Compartilhar uma lembrança com valor afetivo.",
  ],
  Lazer: [
    "Escrever ou desenhar inspirado em suas emoções.",
    "Criar uma playlist com músicas que toquem seu coração.",
    "Dançar sozinho em casa.",
  ],
};

export const emotionLow = {
  Família: [
    "Ligar rapidamente para alguém da família.",
    "Ajudar com algo prático em silêncio.",
    "Estar presente em um momento sem falar muito (ex: sentar junto).",
  ],
  Amor: [
    "Fazer um pequeno gesto de cuidado (café, cobrir com manta).",
    "Compartilhar algo do seu dia.",
    "Fazer um elogio direto e simples.",
  ],
  Carreira: [
    "Atualizar sua lista de metas.",
    "Organizar um processo ou planilha.",
    "Revisar prioridades do mês com objetividade.",
  ],
  Saúde: [
    "Marcar um exame ou consulta.",
    "Cuidar da hidratação com atenção.",
    "Monitorar sono, dor ou alimentação.",
  ],
  Social: [
    "Cumprimentar alguém de forma gentil.",
    "Iniciar uma pequena conversa.",
    "Fazer um elogio simples e direto.",
  ],
  Lazer: [
    "Assistir a algo leve e relaxante.",
    "Jogar algo simples e divertido.",
    "Testar um hobby sem se cobrar.",
  ],
};

export const energyHigh = {
  Família: [
    "Organizar um almoço ou atividade em família.",
    "Criar uma playlist familiar para tocar em encontros.",
    "Ajudar alguém da família com uma tarefa que envolva movimento.",
  ],
  Amor: [
    "Planejar uma surpresa divertida.",
    "Marcar um encontro diferente.",
    "Organizar uma playlist para curtir juntos.",
  ],
  Carreira: [
    "Propor uma nova iniciativa.",
    "Trabalhar com foco em uma tarefa desafiadora.",
    "Convidar alguém para cocriar algo.",
  ],
  Saúde: [
    "Fazer uma caminhada ou treino intenso.",
    "Tentar uma nova modalidade (ex: boxe, dança).",
    "Fazer 30 minutos de atividade aeróbica.",
  ],
  Social: [
    "Participar de um evento social.",
    "Convidar alguém para sair.",
    "Ajudar a organizar um encontro.",
  ],
  Lazer: [
    "Fazer uma trilha ou atividade física leve.",
    "Participar de um jogo ou dança com amigos.",
    "Aprender algo novo por meio da ação (culinária, arte).",
  ],
};

export const energyLow = {
  Família: [
    "Assistir a um filme ou série com a família.",
    "Compartilhar uma foto ou memória pelo celular.",
    "Preparar um lanche simples e dividir com alguém de casa.",
  ],
  Amor: [
    "Ficar abraçado por alguns minutos em silêncio.",
    "Escrever um bilhete de carinho.",
    "Assistir a algo de que ambos gostem.",
  ],
  Carreira: [
    "Organizar o espaço de trabalho por 10 minutos.",
    "Revisar algo já iniciado.",
    "Fazer uma pausa estratégica para clarear ideias.",
  ],
  Saúde: [
    "Alongar o corpo lentamente.",
    "Respirar fundo por 3 minutos.",
    "Tomar banho relaxante como ritual.",
  ],
  Social: [
    "Responder mensagens com calma.",
    "Iniciar uma conversa breve com alguém próximo.",
    "Escrever uma carta ou e-mail para alguém querido.",
  ],
  Lazer: [
    "Ler algo que você ama por 15 minutos.",
    "Ouvir música e relaxar com os olhos fechados.",
    "Pintar, colorir ou bordar com calma.",
  ],
};

export const socialHigh = {
  Família: [
    "Criar um grupo de conversa para manter contato frequente.",
    "Propor um ritual semanal (ex: domingo em família).",
    "Mandar mensagem para vários familiares ao mesmo tempo.",
  ],
  Amor: [
    "Conversar sobre sonhos e planos a dois.",
    "Fazer perguntas abertas para conhecer melhor o outro.",
    "Enviar memes ou conteúdos afetuosos.",
  ],
  Carreira: [
    "Fazer um café com colega para trocar ideias.",
    "Pedir feedback sobre algo recente.",
    "Agendar um alinhamento com time.",
  ],
  Saúde: [
    "Caminhar com um amigo.",
    "Fazer check-up em dupla.",
    "Compartilhar uma meta de saúde com alguém.",
  ],
  Social: [
    "Marcar um café com um amigo.",
    "Participar de grupo com afinidade.",
    "Criar uma lista de contatos para manter o vínculo ativo.",
  ],
  Lazer: [
    "Jogar com amigos.",
    "Ir ao cinema ou parque com alguém.",
    "Fazer algo divertido em grupo pequeno.",
  ],
};

export const socialLow = {
  Família: [
    "Escrever uma mensagem carinhosa e pessoal.",
    "Fazer uma ligação curta só para ouvir a voz de alguém.",
    "Mandar um áudio rápido dizendo que está com saudade.",
  ],
  Amor: [
    "Escutar sem interromper e com atenção total.",
    "Fazer um agrado silencioso (ex: preparar uma bebida).",
    "Sentar perto e apenas curtir a companhia.",
  ],
  Carreira: [
    "Trabalhar em modo foco com pomodoro.",
    "Ler um artigo ou material sozinho.",
    "Entregar uma tarefa sem depender de interações.",
  ],
  Saúde: [
    "Cozinhar algo leve ouvindo música.",
    "Comer uma refeição sozinho com presença.",
    "Meditar ou respirar profundamente sem distrações.",
  ],
  Social: [
    "Fazer uma interação social planejada e breve.",
    "Deixar um bilhete para alguém com carinho.",
    "Comentar algo positivo em uma rede social.",
  ],
  Lazer: [
    "Dedicar tempo a um hobby solo (desenho, escrita).",
    "Caminhar sozinho ouvindo podcast.",
    "Fazer algo manual só para você.",
  ],
};
